import { Link } from 'gatsby';
import React from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import cloudStorage from '../assets/cloud-storage-copy.png';
import cloudStorage2x from '../assets/cloud-storage-copy@2x.png';
import cloudStorage3x from '../assets/cloud-storage-copy@3x.png';
import paths from '../paths';
import srcSet from '../utils/srcSet';
import Heading from './Heading';
import Modal from './Modal';

import responsiveStyles from '../styles/responsive.module.scss';

const messages = defineMessages({
  probePicture: {
    id: 'subscriptionModal.probePicture',
    defaultMessage: 'A Butterfly iQ probe plugged into an iPhone',
  },
});

const propTypes = {};

class SubscriptionModal extends React.Component {
  handleAccept = () => {
    const { onAccept, onHide } = this.props;
    onAccept(true);
    onHide();
  };

  render() {
    const { intl } = this.props;

    return (
      <Modal {...this.props} closeButton center>
        <Modal.Image
          src={cloudStorage}
          srcSet={srcSet(cloudStorage, cloudStorage2x, cloudStorage3x)}
          alt={intl.formatMessage(messages.probePicture)}
        />
        <Modal.Body className={responsiveStyles.textAlignCenter}>
          <Heading level={2}>
            <FormattedMessage
              defaultMessage="Butterfly Subscription"
              id="cloudSubscription.title"
            />
          </Heading>
          <p>
            <FormattedMessage
              defaultMessage="Subscriptions are mandatory for the first year. Users choosing to discontinue after the first year will maintain the ability to scan with the iQ and access their existing studies in their cloud, but will no longer be able to archive new studies."
              id="cloudSubscription.message"
            />
          </p>
          <Link to={paths.termsAndConditions}>
            <FormattedMessage
              defaultMessage="See our full Master Terms and Conditions for details"
              id="cloudSubscription.termsLink"
            />
          </Link>
        </Modal.Body>
      </Modal>
    );
  }
}

SubscriptionModal.propTypes = propTypes;

export default injectIntl(SubscriptionModal);
